<template>
    <div class="text-center">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <h3 class="panel-title">{{ this.announcement.Title }}</h3>
                <a class="action-toggle" href="#" @click="onShow">{{ showBody? "Απόκρυψη": "Εμφάνιση" }}</a>
            </div>
            <div class="panel-body" v-if="showBody">
                <p class="body-text">{{ this.announcement.Body }}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['announcement'],
    data() {
        return {
            showBody: true
        }
    },
    methods: {
        onShow() {
            this.showBody = !this.showBody
        }
    }
}
</script>
<style lang="scss" scoped>
.panel {
    .panel-heading {
        background-color: #6379b3;
        position: relative;
        .action-toggle{
            text-decoration: none;
            color: white;
            position: absolute;
            top:25%;
            right: 22px;
        }
    }
    .panel-body {
        .body-text {
            word-break: break-word;
            display: inline;
            margin-bottom: 0px;
        }
    }
}
</style>